<template>
  <div>
    <zj-layout-container v-loading="loading" element-loading-text="加载中...">
      <zj-layout-header>
        <div class="listtitle">待受理求助</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="上报联系人电话" prop="Phone">
            <el-input v-model="Phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="报警渠道">
            <el-select v-model="SourceDesc" placeholder="请选择报警渠道">
              <el-option
                v-for="item in EmergencyChannel"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.Description"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="求助地点" prop="Location">
            <el-input
              v-model="Location"
              placeholder="请输入求助地点"
            ></el-input>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <!-- <el-button size="mini" @click="onbatchDel">删 除</el-button> -->
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="Location"
                label="求助地点"
              ></el-table-column>
              <el-table-column
                prop="BeginDate"
                label="报警时间"
                :formatter="formatDate"
                width="200"
              ></el-table-column>
              <el-table-column
                prop="SourceDesc"
                label="报警渠道来源"
                width="100"
              ></el-table-column>
              <el-table-column prop="Contact" label="求助人"></el-table-column>
              <el-table-column
                prop="Phone"
                label="求助人联系电话"
                width="160"
              ></el-table-column>
              <el-table-column prop="ProcessStatus" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.ProcessStatus == '0'">待处理</span>
                  <span v-else-if="scope.row.ProcessStatus == '1'">待结案</span>
                  <span v-else-if="scope.row.ProcessStatus == '2'">已完结</span>
                </template>
              </el-table-column>

              <el-table-column fixed="right" label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >处理</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "WaitingHandle",
  controller: "UI",
  action: "WaitingHandle",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      options: [],
      selectData: null,
      TranresourcesType: "",
      ResourceName: "",
      TranresourcesTypeDic: [],
      AlertType: "13", //预警类型
      AlertTypeArr: [],
      AlerteLevel: null, //预警级别
      AlerteLevelArr: [],
      Phone: "", //求助人电话
      Location: "", //求助地点
      SourceDesc: "", //求助渠道
      ProcessStatus: "0", //处理状态 0待处理 1待结案 2已结案
      BeginTime: "",
      EndTime: "",
      EmergencyChannel: [],
      loading: false,
    };
  },
  created: function () {
    this.EmergencyCallChannel();
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "待处理求助查询";
    this.logInfo.LogMessage = "待处理求助查询";
    this.logInfo.ModuleName = "紧急求助";
    this.logInfo.PageName = "待处理求助列表";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    EmergencyCallChannel() {
      //预警来源
      this.config
        .getUValue("EmergencyCall:HelpChannel", "")
        .then((d) => {
          console.log("求助报警的预警来源");
          console.log(d);
          this.EmergencyChannel = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      this.loading = true;
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        ProcessStatus: this.ProcessStatus,
        AlertType: this.AlertType,
        Phone: this.Phone,
        Location: this.Location,
        SourceDesc: this.SourceDesc, //求助渠道
        BeginTime: this.BeginTime, //报警开始时间
        EndTime: this.EndTime, //报警结束时间
      };
      new MyApis.SeekHelpApi()
        .GetAlertItemPagingList(searchInfo)
        .then((r) => {
          this.loading = false;
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    clearsearch() {
      this.Phone = "";
      this.Location = "";
      this.SourceDesc = ""; //求助渠道
    },
    //基础数据绑定
    basedatabind() {
      //所属应急组织类型
      this.config
        .getUValue("EmergencyService:TranresourcesType:", "")
        .then((d) => {
          this.options = d.JValue;
          for (var i = 0; i < this.options.length; i++) {
            var item = this.options[i];
            this.TranresourcesTypeDic[item.ItemKey] = item.Extend1;
          }
        })
        .catch((e) => console.error(e));
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/seekHelp/UI/WaitingForHelpInfo",
        query: {
          Id: row.Id,
          type: "edit",
          ProcessStatus: "0",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/seekHelp/UI/SeekHelpAlarmInfo",
        query: {
          type: "add",
        },
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              new MyApis.TranResourcesApi()
                .DelItemList(selectData)
                .then((r) => {
                  r = r.data.Data;
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                  } else {
                    this.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                  this.search();
                })
                .catch((e) => {
                  console.log(e);
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！",
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.TranresourcesTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>